import { Reference } from '@approvalmax/types';

export const isReference = (value: unknown): value is Reference => {
    return value !== null && typeof value === 'object' && 'id' in value && 'text' in value;
};
